(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9832],{

/***/ 86121:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome",
      function () {
        return __webpack_require__(45608);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HowItWorks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73244);
/* harmony import */ var _howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18074);
// components/howItWorks/howItWorks.tsx





const dict = {
    it: {
        heading: "Il Futuro \xe8 vicino a te.",
        sub: "Tre passi semplici per iniziare su Gloco.",
        items: [
            {
                k: "discover",
                title: "Scopri i negozi locali",
                desc: "Trova prodotti e attivit\xe0 nella tua zona, come in un centro commerciale digitale locale."
            },
            {
                k: "buy",
                title: "Acquista in modo semplice",
                desc: "Ordina online in pochi click. Scegli ritiro in negozio oppure consegna a domicilio."
            },
            {
                k: "support",
                title: "Sostieni la tua comunit\xe0",
                desc: "Ogni acquisto aiuta l’economia locale e valorizza le eccellenze del territorio."
            }
        ],
        cta1: "Vai al Marketplace",
        cta2: "Completa il tuo profilo"
    },
    en: {
        heading: "How it works",
        sub: "Three simple steps to get started with Gloco.",
        items: [
            {
                k: "discover",
                title: "Discover nearby shops",
                desc: "Find products and businesses around you, like a digital local mall."
            },
            {
                k: "buy",
                title: "Buy the simple way",
                desc: "Order in a few clicks. Choose in-store pickup or home delivery."
            },
            {
                k: "support",
                title: "Support your community",
                desc: "Every purchase helps local economy and celebrates local excellence."
            }
        ],
        cta1: "Go to Marketplace",
        cta2: "Complete your profile"
    }
};
function HowItWorks() {
    const { locale  } = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var _locale;
    const t = (_locale = dict[locale]) !== null && _locale !== void 0 ? _locale : dict.it;
    // 👉 funzione che apre il modale "Accedi" e poi clicca "Registrati"
    const openRegisterModal = ()=>{
        // 1️⃣ prova a cliccare il bottone "Accedi" dell'header
        const loginBtn = Array.from(document.querySelectorAll("button")).find((el)=>{
            var ref;
            return ((ref = el.textContent) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase()) === "accedi";
        }) || document.querySelector('button[class*="header_login"]');
        loginBtn === null || loginBtn === void 0 ? void 0 : loginBtn.click();
        // 2️⃣ dopo un piccolo ritardo, clicca il tab/link "Registrati" nel modale
        let tries = 0;
        const interval = setInterval(()=>{
            tries++;
            const registerEl = Array.from(document.querySelectorAll('button, a, [role="button"]')).find((el)=>{
                var ref;
                return ((ref = el.textContent) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase()) === "registrati";
            });
            if (registerEl) {
                registerEl.click();
                clearInterval(interval);
            }
            if (tries > 10) clearInterval(interval); // smette dopo ~1s
        }, 100);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__wrap),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                    className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__head),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: t.heading
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__sub),
                            children: t.sub
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__grid),
                    children: t.items.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__card),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__num),
                                    "aria-hidden": true,
                                    children: "•"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__title),
                                    children: it.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__desc),
                                    children: it.desc
                                })
                            ]
                        }, it.k))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().howitworks__cta),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/",
                            className: "".concat((_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btn), " ").concat((_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["btn--primary"])),
                            children: t.cta1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: "".concat((_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btn), " ").concat((_howItWorks_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["btn--ghost"])),
                            onClick: (e)=>{
                                e.preventDefault();
                                openRegisterModal();
                            },
                            children: t.cta2
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 45608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Welcome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84169);
/* harmony import */ var containers_welcome_welcome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76807);
/* harmony import */ var components_welcomeHero_welcomeHero__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91245);
/* harmony import */ var components_whyChooseUs_whyChooseUs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83957);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88767);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18074);
/* harmony import */ var services_blog__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12838);
/* harmony import */ var components_welcomeBlog_welcomeBlog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74006);
/* harmony import */ var containers_faq_faq__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57945);
/* harmony import */ var services_faq__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46822);
/* harmony import */ var services_page__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70855);
/* harmony import */ var components_howItWorks_howItWorks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81197);
// pages/welcome.tsx













// ⬇️ NEW

var __N_SSG = true;
function Welcome(param) {
    let {} = param;
    var ref, ref1;
    const { locale  } = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const { data  } = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)([
        "landingPage",
        locale
    ], ()=>services_page__WEBPACK_IMPORTED_MODULE_12__/* ["default"].getLandingPage */ .Z.getLandingPage());
    const { data: stats  } = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)([
        "stats",
        locale
    ], ()=>services_page__WEBPACK_IMPORTED_MODULE_12__/* ["default"].getStatistics */ .Z.getStatistics());
    const { data: blog  } = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)([
        "lastBlog",
        locale
    ], ()=>services_blog__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getLastBlog */ .Z.getLastBlog());
    const { data: faqs  } = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)([
        "faqs",
        locale
    ], ()=>services_faq__WEBPACK_IMPORTED_MODULE_11__/* ["default"].getAll */ .Z.getAll());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(containers_welcome_welcome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_welcomeHero_welcomeHero__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        data: data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.data,
                        stats: stats === null || stats === void 0 ? void 0 : stats.data
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_howItWorks_howItWorks__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_whyChooseUs_whyChooseUs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        data: data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.data
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_welcomeBlog_welcomeBlog__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        data: blog === null || blog === void 0 ? void 0 : blog.data
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_faq_faq__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        data: faqs === null || faqs === void 0 ? void 0 : faqs.data
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 73244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"howitworks":"howItWorks_howitworks__iVcWo","howitworks__wrap":"howItWorks_howitworks__wrap__rdEdC","howitworks__head":"howItWorks_howitworks__head__xDzaS","howitworks__sub":"howItWorks_howitworks__sub__79MMq","howitworks__grid":"howItWorks_howitworks__grid__d2bQz","howitworks__card":"howItWorks_howitworks__card___XbDa","howitworks__num":"howItWorks_howitworks__num__qvguO","howitworks__title":"howItWorks_howitworks__title__m0Nqq","howitworks__desc":"howItWorks_howitworks__desc__t5Dty","howitworks__cta":"howItWorks_howitworks__cta__Lb7Ln","btn":"howItWorks_btn__NE9im","btn--primary":"howItWorks_btn--primary__ZHxm0","btn--ghost":"howItWorks_btn--ghost__fkNpQ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4678,5724,1998,3274,9774,2888,179], function() { return __webpack_exec__(86121); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);